import { navRoutes } from "page_routes"
import { ReactNode } from "react"
import { getIeltsMockTestUrl } from "utils/url_utils"
import { batchExamTypeDto } from "DataMapper/IeltsDateUploadData"

export interface FullLengthBannerdata {
  heading: string
  subHeading: string
  ctaText: string
  ctaClick: () => void
  bannerRightImage: string
  tagData?: ReactNode | null
}

export const fullLengthBannerData: FullLengthBannerdata = {
  heading: "Self prep bundle",
  subHeading:
    "Practice full length, sectional mock test and recordings to learn from",
  bannerRightImage: `${process.env.CDN_URL}/assets/images/banner_image_right.png`,
  ctaText: "Practice Now",
  ctaClick: () => window.open(getIeltsMockTestUrl(`/self-prep`), "_self"),
}
export const speakingTestBannerData = {
  heading: "Speaking Practice",
  subHeading: "Schedule a speaking session",
  rightImageWeb: "/assets/images/banner/speaking_banner_girl_web.png",
  rightImageMob: "/assets/images/banner/speaking_banner_girl_mob.png",
  handleClick: () => {
    window.open(navRoutes.IELTS_SPEAKING_CLUB, "_self")
  },
}

export enum WritingExamPreference {
  CBT = "CBT",
  PBT = "PBT",
}

export const writingPreferanceCardData = (isMobile: boolean) => {
  return {
    heading: "Please select your preferred mode of Writing Test",
    preferenceOptions: [
      {
        value: WritingExamPreference.PBT,
        image: "/assets/images/ielts/writing_hand.svg",
        title: "Paper based test",
        subtitile: "Upload your answers",
      },
      {
        value: WritingExamPreference.CBT,
        image: "/assets/images/ielts/montior.svg",
        title: "Computer based test",
        subtitile: "Type your answers",
        isDisabled: isMobile,
        tag: isMobile ? "Only available on desktop" : "",
      },
    ],
    ctaText: "Start Test",
  }
}

export enum ExamLiveStatus {
  STARTED = "STARTED",
  NOT_STARTED = "NOT_STARTED",
  ATTEMPTED = "ATTEMPTED",
  ENDED = "ENDED",
  NOT_ATTEMPTED = "NOT_ATTEMPTED",
  EVALUATED = "EVALUATED",
}

export const EXPERIMENT_SALES_LEAD = "EXPERIMENT_SALES_LEAD"

export const audienceSelectList: Array<{ id: string; text: string }> = [
  {
    id: batchExamTypeDto.ACADEMIC,
    text: "Academic",
  },
  {
    id: batchExamTypeDto.GENERAL,
    text: "General",
  },
]
